export const onClick = (
  sku: string,
  sellerId: string,
  salesPrice: number,
  isSelected: boolean | undefined,
  id: string,
  condition: string,
  handleClick: (prop: Record<string, unknown>) => void
) => () => handleClick({ sku, sellerId, salesPrice, isSelected, id, condition });
